/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Stack, Typography } from "@mui/material";
import { FC, type JSX } from "react";

import TestIds from "../../../../testIds";

const CostPriceEmpty: FC = (): JSX.Element => (
  <Stack
    data-testid={TestIds.feat.costPrice.empty.component}
    alignItems="center"
    justifyContent="center"
    minHeight="150px"
  >
    <Typography variant="default" color="accent">
      No cost price available
    </Typography>
  </Stack>
);

export default CostPriceEmpty;
